<div class="card card-stretch h-100 rounded-0 context-menu">
    <div class="card-header p-3 d-flex justify-content-between border-bottom-0">
        <h5 class="card-title mb-0 font-weight-bolder">
            <img src="../../../../assets/common/images/Activities/timesheetSectionIcon.svg" class="h-20px w-20px mr-2" />   {{'MyTimesheet'|localize}}
        </h5>
        <div *ngIf="isLoaded && !isTimesheetRecordsEmpty"  class="ml-auto cursor-pointer card-toolbar">
            <div class="font-weight-bolder text-primary cursor-pointer" (click)="viewall()">
                {{ 'ViewAll' | localize}}
            </div>
        </div>
    </div>

    <div class="card-body p-0 pb-3">

        <!--Shimmer Code-->
        <div *ngIf="!isLoaded &&  isTimesheetRecordsEmpty">
            <div class="row px-4">
                <div class="col-md-2">

                    <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                </div>

                <div class="col-md-2">

                    <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                </div>

                <div class="col-md-2">

                    <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                </div>

                <div class="col-md-2">

                    <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                </div>
                <div class="col-md-2">

                    <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                </div>

                <div class="col-md-2">

                    <ngx-shimmer-loading [width]="'100%'" [height]="'60px'"></ngx-shimmer-loading>


                </div>

            </div>
        </div>

        <!--Empty State UI Code-->
        <div *ngIf="isLoaded && isTimesheetRecordsEmpty">
            <div class="card h-350px">
                <div class="d-flex justify-content-center">
                    <div class="d-flex flex-column mt-20">
                        <img src="../../../../assets/common/images/new-dashboard/timesheet-empty.png" class="h-200px w-275px ml-8" />
                        <h6 class="text-muted text-center mt-4 ml-25">{{'NoDataFounds'|localize}}</h6>
                    </div>
                </div>
            </div>


        </div>

        <!--TimeSheet Code-->

        <div *ngIf="isLoaded && !isTimesheetRecordsEmpty">
            <div class="row px-4">
                <div class="col-md-12">
                    <div id="dashBoard-Timesheet-data-table">
                        <p-table [value]="myDashboardDetails" [rows]="5" [paginator]="true" [alwaysShowPaginator]="false">
                            <ng-template pTemplate="header">
                                <tr [ngClass]="'textcolor'">
                                    <th>{{'ProjectName'|localize}}</th>
                                    <th>{{'TimesheetDate'|localize}}</th>
                                    <th >{{'TimeOffSubmittedOn'|localize}}</th>


                                    <!--<th style="width: 14% !important;">{{'SubmissionFrequency'|localize}}</th>-->
                                    <th>{{'RequiredHrs'| localize}}</th>
                                    <th>{{'LoggedHrs'|localize}}</th>
                                    <th>{{'BilledHrs' |localize}}</th>
                                    <th>{{'Status'|localize}}</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-DashboardMyTimesheetDto>
                                <tr [ngClass]="'textcolor bg-hover-gray-100'" id="pointerClassOrg">
                                    <td>

                                        <div class="d-flex">
                                            <div class="d-flex align-items-center">
                                                <div class="w-35px h-35px">
                                                    <img [src]="DashboardMyTimesheetDto.projectImage" class="img-responsive w-35px h-35px border border-light rounded p-1 center-block d-block mx-auto" id="profimgsize" />

                                                </div>
                                            </div>
                                            <div class="d-flex flex-column justify-content-center p-1">
                                                <div class="font-weight-bold" pTooltip="{{DashboardMyTimesheetDto.projectName}}" [tooltipDisabled]="DisableTooltip(DashboardMyTimesheetDto.projectName, 16)" tooltipPosition="bottom">{{DashboardMyTimesheetDto.projectName | slice:0:15}}{{DashboardMyTimesheetDto.projectName.length > 15 ? '...' : '' }} </div>
                                                <span class="d-flex">
                                                    <span class="mr-1">
                                                        <img *ngIf="DashboardMyTimesheetDto?.projectType===1" src="assets/common/images/billable.png" alt="" width="15px" class="ml-1" pTooltip="{{'Billable' |localize}}" tooltipPosition="bottom">
                                                        <img *ngIf="DashboardMyTimesheetDto?.projectType===2" src="assets/common/images/nonbillable.png" alt="" width="15px" class="ml-1" pTooltip="{{'NonBillable' |localize}}" tooltipPosition="bottom"> |
                                                    </span>
                                                    <span *ngIf="DashboardMyTimesheetDto.projectCurrentStatus == 1" class="text-dark-50 font-size-xs mr-2 mt-1">{{'New' | localize}}</span>
                                                    <span *ngIf="DashboardMyTimesheetDto.projectCurrentStatus == 2" class="text-dark-50 font-size-xs mr-2 mt-1">{{'Active' | localize}}</span>
                                                    <span *ngIf="DashboardMyTimesheetDto.projectCurrentStatus == 3" class="text-dark-50 font-size-xs mr-2 mt-1">{{'Complete' | localize}}</span>
                                                    <span *ngIf="DashboardMyTimesheetDto.projectCurrentStatus == 4" class="text-dark-50 font-size-xs mr-2 mt-1">{{'Closed' | localize}}</span>
                                                    <span *ngIf="!DashboardMyTimesheetDto.projectCurrentStatus" class="text-dark-50 font-size-xs mr-2 mt-1">{{'Notavailable' | localize}}</span>

                                                </span>
                                            </div>
                                        </div>
                                    </td>

                                    <!--Timesheet Date-->
                                    <td>

                                        <div>
                                            <div>{{ DashboardMyTimesheetDto.fromDate | dateFormat }}<span> - {{ DashboardMyTimesheetDto.toDate | dateFormat }}</span></div>
                                        </div>

                                    </td>

                                    <!--Submission Date-->

                                    <td>{{DashboardMyTimesheetDto.submitedDate | dateFormat }}</td>






                                    <!--Submission Frequency-->
                                    <!--<td>




                                        <span>
                                            {{ _tus.getTimesheetFrequency(DashboardMyTimesheetDto.timesheetFrequency)| localize}}
                                        </span>



                                    </td>-->


                                    <!--Required Hours-->

                                    <td>

                                        <span class="mr-2  justify-content-center">
                                            <span class="font-weight-bolder text-info"> {{ _tus.getHoursAndMinStringWithColon(DashboardMyTimesheetDto.requiredHours) }}</span>
                                        </span>

                                    </td>

                                    <!--Submitted Hours-->
                                    <td>

                                        <span class="mr-2   justify-content-center">
                                            <span class=" text-warning font-weight-bolder"> {{ _tus.getHoursAndMinStringWithColon(DashboardMyTimesheetDto.submitedHours) }} </span>
                                        </span>
                                    </td>



                                    <!--Billed Hours-->
                                    <td>
                                        <span>
                                            <span class="font-weight-bolder text-success"> {{ _tus.getHoursAndMinStringWithColon(DashboardMyTimesheetDto.billedHours)}}</span>
                                        </span>

                                    </td>


                                    <!--Status-->
                                    <td>
                                        <!-- [ngClass]=" {'border-warning': DashboardMyTimesheetDto.timesheetStatus == 2 || DashboardMyTimesheetDto.timesheetStatus == 4,'border-danger': DashboardMyTimesheetDto.timesheetStatus == 3,'border-success': DashboardMyTimesheetDto.timesheetStatus == 1}" -->
                                        <div class="label label-outline-secondary rounded-pill h-28px w-75px label-inline border bg-white  justify-content-center">
                                            <span class="label label-dot" [ngClass]="{'label-success': DashboardMyTimesheetDto.timesheetStatus == 1,'label-warning': (DashboardMyTimesheetDto.timesheetStatus == 2 ||DashboardMyTimesheetDto.timesheetStatus == 4 ),'label-danger': DashboardMyTimesheetDto.timesheetStatus == 3}"></span>
                                            <span *ngIf="DashboardMyTimesheetDto.timesheetStatus == 1" class="ml-2">{{'Approved'|localize}}</span>
                                            <span *ngIf="DashboardMyTimesheetDto.timesheetStatus == 2" class="ml-2">{{'Pending'|localize}}</span>
                                            <span *ngIf="DashboardMyTimesheetDto.timesheetStatus == 3" class="ml-2">{{'Rejected' | localize}}</span>
                                            <span *ngIf="DashboardMyTimesheetDto.timesheetStatus == 4" class="ml-2">{{'Overdue'|localize}}</span>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>

                </div>
            </div>
        </div>


    </div>
</div>


